/* eslint-disable */
import React, { useState, useRef } from 'react';

import {
  Box,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  IconButton,
  Menu,
  MenuItem,
  Popover,
  Typography,
  Divider,
  TextField,
  darken,
  lighten,
} from '@mui/material';
import { withStyles } from 'tss-react/mui';

import ReportProblemIcon from '@mui/icons-material/ReportProblemOutlined';
import { Bar } from 'react-chartjs-2';
import InfoIcon from '@mui/icons-material/Info';
import EditIcon from '@mui/icons-material/Edit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { makeStyles } from 'tss-react/mui';
import { useTheme } from '@mui/material/styles';

import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import SendIcon from '@mui/icons-material/Send';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import StarBorder from '@mui/icons-material/StarBorder';

// import FullCalendar from '@fullcalendar/react';
// import timeGridPlugin from '@fullcalendar/timegrid';
// import interactionPlugin from '@fullcalendar/interaction';
// import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';

import {
  FormTextField,
  FormSelect,
  FormDateField,
  FormTimeField,
  FormNumberFormatField,
} from 'components/forms/FormikFields';

import ServiceAutocomplete from 'components/forms/dropdowns/ServiceAutocomplete';
import CustomerAutocomplete from 'components/forms/dropdowns/CustomerAutocomplete';
import showNotification from 'commons/helpers/showNotification';
import { Formik, Form, Field } from 'formik';
import TableCellAction from 'components/table/TableCellAction';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import AppointmentService from 'services/AppointmentService';
import AccountsReceivableService from 'services/AccountsReceivableService';
import DurationUtils from 'commons/utils/durationUtils';
import PaymentMethods from 'commons/enums/paymentMethods';

import yup from 'commons/validations';
import { COLORS } from 'commons/helpers/agendaTheme';

import moment from 'moment';
import NumberUtils from 'commons/utils/numberUtils';
import ColorPicker from 'components/pickers/ColorPicker';
// import DownshiftComplete from 'components/forms/dropdowns/DownshiftComplete';
import TestCombo from './TestCombo';
import MonthYearPicker from 'components/inputs/MonthYearPicker';
import { Autocomplete } from '@mui/material';
import { createFilterOptions } from '@mui/material/useAutocomplete';
import HintText from 'components/labels/HintText';
import ProductService from 'services/ProductService';
import ButtonStatus from 'components/buttons/ButtonStatus';
import Downshift from 'downshift';
import CustomerDownshift from 'components/forms/dropdowns/CustomerDownshift';
import ServiceDownshift from 'components/forms/dropdowns/ServiceDownshift';
import WhatsUtils from 'commons/utils/whatsUtils';
import { FontAwesomeIconStatus } from 'components/icon/FontAwesomeIconStatus';
import FontAwesomeDoubleIconStatus from 'components/icon/FontAwesomeDoubleIconStatus';
const filter = createFilterOptions();
// import Typography from '../Typography';

// import AppointmentsGridNew from './AppointmentsGridNew';
// import AppointmentsGrid2 from './AppointmentsGrid2';

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  rowHeader: {
    background: '#e8e8e8',
    cursor: 'pointer',
    '&:hover': {
      background: lighten(theme.palette.primary.light, 0.8),
    },
  },
}));

const rows = [
  {
    id: 1,
    name: 'Bruna',
    customerId: 1,
    date: '2021-01-15',
    startTime: '09:00',
    service: 'Maquiagem',
    price: 90,
    totalPaid: 0,
  },
  {
    id: 2,
    name: 'Bruna',
    customerId: 1,
    date: '2021-01-15',
    startTime: '19:00',
    service: 'Sobrancelha',
    price: 30,
    totalPaid: 0,
  },
  {
    id: 3,
    name: 'Camila',
    customerId: 2,
    date: '2021-01-14',
    startTime: '09:00',
    service: 'Maquiagem',
    price: 90,
    totalPaid: 0,
  },
];

const ExpandableTableRow = ({ children, row }) => {
  const { classes } = useStyles();
  const [isExpanded, setIsExpanded] = React.useState(true);

  return (
    <>
      {/* EXPANDEABLE */}
      <TableRow className={classes.rowHeader} onClick={() => setIsExpanded(!isExpanded)}>
        <TableCell padding="checkbox">
          <IconButton size="large">
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row" colSpan="6">
          {row.name}
        </TableCell>
        <TableCell component="th" scope="row">
          Devendo: R$ 80,00
          <FontAwesomeIconStatus icon="file-invoice" status="primary" style={{ marginLeft: '1rem' }} />
        </TableCell>
      </TableRow>
      {/* LIST */}
      {isExpanded && (
        <TableRow>
          <TableCell padding="checkbox" />
          <TableCell />
          <TableCell>{row.date}</TableCell>
          <TableCell>{row.startTime}</TableCell>
          <TableCell>{row.serviceName}</TableCell>
          <TableCell>{row.price}</TableCell>
          <TableCell>{row.totalPaid}</TableCell>
        </TableRow>
      )}
    </>
  );
};

// COMPONENT
function PlaygroundPage() {
  const { classes } = useStyles();

  const myHandleSubmit = () => {};

  return (
    <div style={{ margin: '20px' }}>
      <Paper className={classes.root}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" />
              <TableCell>Cliente</TableCell>
              <TableCell>Data</TableCell>
              <TableCell>Horário</TableCell>
              <TableCell>Serviço</TableCell>
              <TableCell>Preço</TableCell>
              <TableCell>Total Pago</TableCell>
              <TableCell style={{ width: '200px' }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <ExpandableTableRow key={row.id} row={row} />
            ))}
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}

export default PlaygroundPage;
